import produce from "immer"
import { ASC } from "const"
import { MtGroup } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initGroup: MtGroup = {
    id: null,
    accountId: null,
    name: "",
    description: "",
    creator: null,
}

const initGroupState: types.GroupState = {
    groupList: {},
    groupIds: [],
    groupView: initGroup,
    groupEdit: initGroup,

    accountGroups: null,

    sortColumn: "name",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadView: true,
    reloadEdit: true,
}

const groupReducer = produce((
    draft: types.GroupState = initGroupState,
    action: ActionTypes = null,
): types.GroupState => {
    switch (action.type) {
        case types.GROUP_LIST:
            draft.groupList = action.groupList
            return draft

        case types.GROUP_IDS:
            draft.groupIds = action.groupIds
            return draft

        case types.GROUP_VIEW:
            draft.groupView = action.group
            return draft

        case types.GROUP_EDIT:
            draft.groupEdit = action.group
            return draft

        case types.ACCOUNT_GROUPS:
            draft.accountGroups = action.groups
            return draft

        case types.GROUP_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.GROUP_FILTERS:
            draft.filters = action.filters
            return draft

        case types.GROUP_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.GROUP_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.GROUP_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default groupReducer
